var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("path", {
      attrs: {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "M28.5 57L57 28.5 28.5 0l-5.034 5.034 19.881 19.967H0V32h43.347L23.466 51.966z",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }